import * as firebaseApp from "firebase/app";
import * as firebaseAnalytics from "firebase/analytics";
import * as firebaseAuth from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import * as firebaseStorage from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Fix for firebase types not exporting members correctly in some environments
const { getAuth, GoogleAuthProvider } = firebaseAuth as any;
const { initializeApp } = firebaseApp as any;
const { getStorage } = firebaseStorage as any;
const { getAnalytics } = firebaseAnalytics as any;

// ------------------------------------------------------------------
// IMPORTANT: Replace the values below with your Firebase project config
// You can find these in the Firebase Console -> Project Settings
// ------------------------------------------------------------------
const firebaseConfig = {
  apiKey: "AIzaSyCevgN7I3jOps46XdXeDvY3RMqggfbXjHg",
  authDomain: "loveonread-24e69.firebaseapp.com",
  projectId: "loveonread-24e69",
  storageBucket: "loveonread-24e69.firebasestorage.app",
  messagingSenderId: "948720803568",
  appId: "1:948720803568:web:6458849318db5de110ac35",
  measurementId: "G-B211H5785F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics safely
let analytics;
try {
  analytics = getAnalytics(app);
} catch (e) {
  console.warn("Firebase Analytics failed to initialize", e);
}

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);